module.exports = __webpack_public_path__ + "cf68091a1ebf03c6887c5011a6158e74.svg";